"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _ClickOutside = _interopRequireDefault(require("../ClickOutside"));
var Styled = _interopRequireWildcard(require("./styles/contextMenu"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ButtonGroupContext = (0, _react.memo)(({
  data = [],
  comps = []
}) => {
  const [isActive, setActive] = (0, _react.useState)(false);
  const [hoverItemIndex, setHoverItem] = (0, _react.useState)(-1);
  const triggerContextMenu = () => {
    setActive(!isActive);
  };
  const closeContextMenu = () => {
    if (isActive) {
      setActive(false);
    }
  };
  const handleItemClick = (item, event) => {
    if (item.disabled) {
      event.stopPropagation();
    } else {
      item.onClick();
    }
  };
  const handleMouseEnterItem = (item, index) => () => {
    setHoverItem(item.disabled ? -1 : index);
  };
  const handleMouseLeaveItem = () => {
    setHoverItem(-1);
  };
  return _react.default.createElement(_ClickOutside.default, {
    onClickOutside: closeContextMenu
  }, _react.default.createElement(Styled.ContextMenu, {
    onClick: triggerContextMenu,
    active: isActive,
    lastItemHovered: hoverItemIndex + 1 === data.length
  }, _react.default.createElement(Styled.ContextMenuList, {
    isContextMenuListOpen: isActive
  }, data.map((item, index) => _react.default.createElement(Styled.ContextMenuItem, {
    key: index,
    isDisabled: item.disabled || !item.onClick,
    onMouseEnter: handleMouseEnterItem(item, index),
    onMouseLeave: handleMouseLeaveItem,
    onClick: event => {
      handleItemClick(item, event);
    }
  }, _react.default.createElement(Styled.ContextMenuItemCaption, {
    isDisabled: item.disabled || !item.onClick
  }, item.title))), comps.map(comp => [comp])), _react.default.createElement(Styled.TogglerIcon, null)));
});
var _default = exports.default = (0, _styledComponents.withTheme)(ButtonGroupContext);